export class  ConstantsUtil{
    public static readonly errorMessages = {
        EMPTY_PLEASE_CHOOSE_A_FILE: 'Empty! Please choose a file.',
        INCORRECT_FILE_UPLOADED_PLEASE_RENAME_THE_FILE_TO_THIS_FORMAT:'Incorrect file uploaded. Please rename the file to this format.',
        ONLY_XLSM_XLSX_AND_CSV_IS_SUPPORTED:'Only .xlsm, .xlsx and .csv is supported!',
        CANNOT_USE_MULTIPLE_FILES:'Cannot use multiple files',
        ERROR: 'Error'
    }

    public static readonly prefixes = {
        ENTITYVIEWER_UNDERSCORE: 'EntityViewer_',
        UNDERSCORE: '_'
    }

    public static readonly constants = {
        HEADER_APP_NAME: 'headerApp',
        OH_ENTITY_VIEWER_TEMPLATE_UPLOAD_UI: 'oh-entity-viewer-template-upload-ui',
        ADMIN_ERROR: {
            ERROR_MESSAGE: "LIMITED ACCESS ISSUE",
            ERROR_RESOLUTION_TEXT: "To see data please contact your admin to access Entity Viewer."
        }
    }



    public static readonly routes = {
        SLASH_HOME: '/home',
        SLASH_LOGIN: '/login',
        SLASH_ADMIN_ERROR: '/admin-error'
    }

    public static readonly events = {
        TO_HOME: 'toHome',
        TO_GLOBE: 'toGlobe',
        LOGIN_TO_AD: 'loginToAD',
        NAVIGATE_TO_LOGIN: 'navigateToLogin',
        DRAG_OVER: 'dragover'
    }

    public static readonly roles = {
        ADMIN_OH: 'Admin_OH'
    }
}